import { useEffect } from "react";
import { useCart } from "@/context/CartContext";

export default function Checkout() {
  const { cart, goToCheckout } = useCart();

  useEffect(() => {
    if (cart?.checkoutUrl) {
      goToCheckout();
    }
  }, [cart, goToCheckout]);

  return (
    <div
      className="bg-black min-h-screen flex items-center justify-center text-white wc-label text-sm tracking-widest"
      data-testid="checkout-page"
    >
      {cart?.checkoutUrl ? "REDIRECTING TO SECURE CHECKOUT…" : "YOUR CART IS EMPTY"}
    </div>
  );
}
